import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Duration } from 'luxon';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { provideTrackingCtx } from 'src/app/services/tracking/context';

export type TimeTubeLog = { start: Duration, end: Duration };
type TimeTubeItem = TimeTubeLog & { left: number, width: number };

@Component({
  selector: 'app-timetube-basic',
  templateUrl: './timetube.component.html',
  styleUrls: ['./timetube.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideTrackingCtx({}),
  ],
})
export class TimetubeBasicComponent {
  @Output() clickLog = new EventEmitter<TimeTubeLog>();

  logs$ = new BehaviorSubject<TimeTubeLog[]>(undefined);
  @Input() set logs(value: TimeTubeLog[]) { this.logs$.next(value); }

  items$: Observable<TimeTubeItem[]> =
    this.logs$.pipe(
      map(log => (log || []).map(x => ({
        ...x,
        left: x.start.as('hours') / 24 * 100,
        width: (x.end.as('hours') - x.start.as('hours')) / 24 * 100,
      }))),
      shareReplay(1),
    );

  ruler$ = new BehaviorSubject<'6' | '12' | '24'>('24');
  @Input() set ruler(value: '6' | '12' | '24') {
    this.ruler$.next(value);
  }

  trackBy(index, item: TimeTubeItem) {
    return item.start;
  }
}
